import $ from 'jquery';
import magnificPopup from 'magnific-popup';


/* Global variables
********************************************/

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function setModalCookie(modalId) {
	setCookie('mod_' + modalId, '1', false);
}

/* Bootstrap Modals
********************************************/

if ($('.js-load-modal').length) {
	$(window).on('load', function() {
		$('.js-load-modal').modal('show').on('hide.bs.modal', function(event) {
			setModalCookie(event.target.dataset.modalId);
		  });
	});
}

if ($('.modal-link-close').length) {
	$('.modal-link-close').on('click', function(e) {
		if (this.dataset.modalId) {
			setModalCookie(this.dataset.modalId);
		}
	});

}


/* Modals
********************************************/

if ($.fn.magnificPopup) {
	$('.js-mfp-image').magnificPopup({
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		image: {
			verticalFit: true
		},
		closeMarkup: '<button title="%title%" type="button" class="btn-close btn-close-white btn-close-overlay" aria-label="Close"></button>'
	});

	$('.js-mfp-video').magnificPopup({
		disableOn: 0,
		type: 'iframe',
		closeBtnInside: false,
		mainClass: 'mfp-fade',
		preloader: false,
		fixedContentPos: false,
		iframe: {
			markup: '<div class="mfp-iframe-scaler">' +
				'<div class="mfp-close"></div>' +
				'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
				'</div>',
			patterns: {
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
					src: 'https://www.youtube.com/embed/%id%?autoplay=1'
				},
				vimeo: {
					index: 'vimeo.com/',
					id: '/',
					src: '//player.vimeo.com/video/%id%?autoplay=1'
				}
			}
		},
		callbacks: {
			open: function(){
				window.__vimeoRefresh();
			}
		},
		closeMarkup: '<button title="%title%" type="button" class="btn-close btn-close-white btn-close-overlay" aria-label="Close"></button>'
	});

	$('.c-article__image-link').not('[target="_blank"]').magnificPopup({
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		image: {
			verticalFit: true
		},
		closeMarkup: '<button title="%title%" type="button" class="btn-close btn-close-white btn-close-overlay" aria-label="Close"></button>'
	});

	$('.js-mfp-base').magnificPopup({
		closeOnContentClick: false,
		showCloseBtn: false,
	});

	// close modal
	$('body').on('click', '.js-mfp-close', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

}



/* Wistia Modals
********************************************/

/**
 * Wistia has this functionality built in if you start the href with only "#wistia_XXX", XXX being video ID, but the
 * native functinality it provides fails to open a modal when there's a video with the same video ID displayed inline
 * on the page so I've implemented this to fix that.
 *
 * This also fails, when using span.wistia_embed id attr as a matcher argument as described here:
 * https://wistia.com/support/developers/player-api#wistia-api-matcher , it appends an iframe to inline video when the
 * modal closes.
 */
$( document ).on( 'click', '[href^="#wistia-modal-"]', function ( e ) {
	e.preventDefault();
	const $playLink = $( $( this ).attr( 'href' ) + ' a' );
	if ( $playLink.length ) {
		$playLink[0].click();
	}
} );
